import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { PlayerProvider } from "@/context/PlayerContext";
import { ChatProvider } from "@/context/ChatContext";
import { AdminProvider } from "@/context/AdminContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import GfnSoulOnDemand from "@/pages/GfnSoulOnDemand";
import GfnSoulNycTv from "@/pages/GfnSoulNycTv";
import Contact from "@/pages/Contact";
import Install from "@/pages/Install";
import Schedule from "@/pages/Schedule";
import StationPage from "@/pages/StationPage";
import Admin from "@/pages/Admin";
import News from "@/pages/News";
import SplashScreen, { shouldShowSplash } from "@/components/SplashScreen";
import AlertsManager from "@/components/AlertsManager";

function App() {
  const [showSplash, setShowSplash] = useState(() => shouldShowSplash());
  return (
    <div className="App">
      {showSplash && <SplashScreen onDone={() => setShowSplash(false)} />}
      <AlertsManager />
      <AdminProvider>
        <PlayerProvider>
          <ChatProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<Landing />} />
                  <Route path="gfn-tv" element={<GfnSoulNycTv />} />
                  <Route path="on-demand" element={<GfnSoulOnDemand />} />
                  <Route path="fft-world-tv" element={<Navigate to="/on-demand" replace />} />
                  <Route path="contact" element={<Contact />} />
                  <Route path="install" element={<Install />} />
                  <Route path="fm151" element={<StationPage stationId="fm151" />} />
                  <Route path="vibe" element={<StationPage stationId="vibe" />} />
                  <Route path="schedule" element={<Schedule />} />
                  <Route path="news" element={<News />} />
                  <Route path="admin" element={<Admin />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </ChatProvider>
        </PlayerProvider>
      </AdminProvider>
    </div>
  );
}

export default App;
